import React, { useState } from "react";
import "../Event/AdminEvent.css";

interface TransportDepartureDto {
    transportId?: number;
    country?: string;
    departureDate?: string;
    departureTime?: string; // HH:mm
    departureFlightNo?: string;
    contactperson?: string;
    contactpersonEmail?: string;
    contactpersonMobile?: string;
    numberOfPersons?: number;
    numberOfLuggage?: number;
}

const FormTransportDepartureCreate: React.FC = () => {
    const [formData, setFormData] = useState<TransportDepartureDto>({
        country: "",
        departureDate: "",
        departureTime: "",
        departureFlightNo: "",
        contactperson: "",
        contactpersonEmail: "",
        contactpersonMobile: "",
        numberOfPersons: 0,
        numberOfLuggage: 0,
    });

    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: type === "number" ? Number(value) : value,
        }));
    };

    const validateForm = (): boolean => {
        if (!formData.country?.trim())
            return setError("Country skal udfyldes"), false;

        if (!formData.departureDate)
            return setError("Departure Date skal udfyldes"), false;

        if (!formData.departureTime)
            return setError("Departure Time skal udfyldes"), false;

        if (!formData.departureFlightNo?.trim())
            return setError("Flight No skal udfyldes"), false;

        if (!formData.contactperson?.trim())
            return setError("Contact Person skal udfyldes"), false;

        if (!formData.contactpersonEmail?.trim())
            return setError("Email skal udfyldes"), false;

        if (!formData.contactpersonMobile?.trim())
            return setError("Mobile skal udfyldes"), false;

        if (!formData.numberOfPersons || formData.numberOfPersons <= 0)
            return setError("Number of Persons skal være større end 0"), false;

        if (!formData.numberOfLuggage || formData.numberOfLuggage <= 0)
            return setError("Number of Luggage skal være større end 0"), false;

        setError(null);
        return true;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setSuccess(null);

        if (!validateForm()) return;

        const payload = {
            ...formData,
            departureTime: `${formData.departureTime}:00`, // HH:mm:ss
        };

        try {
            const response = await fetch("/api/form_transport/departure", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const text = await response.text();
                throw new Error(text || "Fejl ved oprettelse af departure transport");
            }

            await response.json();
            setSuccess("✅ Departure transport oprettet succesfuldt!");

            setFormData({
                country: "",
                departureDate: "",
                departureTime: "",
                departureFlightNo: "",
                contactperson: "",
                contactpersonEmail: "",
                contactpersonMobile: "",
                numberOfPersons: 0,
                numberOfLuggage: 0,
            });
        } catch (err: any) {
            setError(`Fejl: ${err.message}`);
        }
    };

    return (
        <div className="form-container">
            <h2>Transport Departure request</h2>

            {error && <p className="error-message">{error}</p>}
            {success && <p className="success-message">{success}</p>}

            <form onSubmit={handleSubmit}>
                <label>Country *</label>
                <input type="text" name="country" value={formData.country} onChange={handleChange} />

                <label>Departure Date *</label>
                <input type="date" name="departureDate" value={formData.departureDate} onChange={handleChange} />

                <label>Departure Time *</label>
                <input type="time" name="departureTime" value={formData.departureTime} onChange={handleChange} />

                <label>Flight No *</label>
                <input type="text" name="departureFlightNo" value={formData.departureFlightNo} onChange={handleChange} />

                <label>Contact Person *</label>
                <input type="text" name="contactperson" value={formData.contactperson} onChange={handleChange} />

                <label>Email *</label>
                <input type="email" name="contactpersonEmail" value={formData.contactpersonEmail} onChange={handleChange} />

                <label>Mobile *</label>
                <input type="text" name="contactpersonMobile" value={formData.contactpersonMobile} onChange={handleChange} />

                <label>Number of Persons *</label>
                <input type="number" name="numberOfPersons" min={1} value={formData.numberOfPersons} onChange={handleChange} />

                <label>Number of Luggage *</label>
                <input type="number" name="numberOfLuggage" min={1} value={formData.numberOfLuggage} onChange={handleChange} />

                <button type="submit" className="add-btn">
                    Opret Departure Transport
                </button>
            </form>
        </div>
    );
};

export default FormTransportDepartureCreate;